"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodashEs = require("lodash-es");
var _sanner = _interopRequireDefault(require("@/utils/sanner"));
var _inventory = require("@/api/inventory");
var _store = require("@/api/store");
var _util = require("@/utils/util");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var basicForm = {
  barcode: '',
  brand: '',
  childBarcode: '',
  childGoodsId: '',
  convertQty: '',
  name: '',
  spec: '',
  status: 1,
  remark: ''
};
var _default = exports.default = {
  name: 'Editor',
  data: function data() {
    return {
      dialogVisible: false,
      formData: {},
      childGoodsText: '',
      debounceFunc: null,
      scanner: null,
      formRules: {
        name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        brand: [{
          required: true,
          message: '请输入商品品牌',
          trigger: 'blur'
        }],
        spec: [{
          required: true,
          message: '请输入商品规格',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    editorType: function editorType() {
      return this.formData.id ? '编辑' : '新增';
    }
  },
  created: function created() {
    this.debounceFunc = (0, _lodashEs.debounce)(this.onGoodsSearch, 300);
  },
  mounted: function mounted() {
    this.scannerInit();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.scanner) {
      this.scanner.stop();
      this.scanner = null;
    }
  },
  methods: {
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
        var _this = this;
        var childGoods;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.formData = Object.assign({}, basicForm);
              if (data) {
                (0, _util.assignSameProps)(data, this.formData);
                this.formData.id = data.id;
              }
              if (!(data && data.childGoodsId)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return (0, _inventory.getInventoryGoodsDetail)(data.childGoodsId);
            case 1:
              childGoods = _context.v;
              this.childGoodsText = childGoods && childGoods.name ? childGoods.name : '';
              _context.n = 3;
              break;
            case 2:
              this.childGoodsText = '';
            case 3:
              this.dialogVisible = true;
              this.$nextTick(function () {
                if (_this.scanner) {
                  _this.scanner.start();
                }
              });
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open(_x) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    close: function close() {
      if (this.scanner) {
        this.scanner.stop();
      }
      this.dialogVisible = false;
    },
    resetForm: function resetForm() {
      this.formData = Object.assign({}, basicForm);
      this.childGoodsText = '';
    },
    scannerInit: function scannerInit() {
      var _this2 = this;
      this.scanner = new _sanner.default(function (code) {
        _this2.onGoodsScanQuery(code);
      }, {
        preventInput: true,
        minLength: 3,
        timeInterval: 100
      });
    },
    onGoodsScanQuery: function () {
      var _onGoodsScanQuery = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(code) {
        var res, obj, originalData, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _store.getBarcodeInfo)(code);
            case 1:
              res = _context2.v;
              if (res.showapi_res_code === 0 && res.showapi_res_body) {
                obj = res.showapi_res_body;
                originalData = (0, _lodashEs.cloneDeep)(this.formData);
                this.formData.barcode = code;
                this.formData.brand = obj.trademark || originalData.brand;
                this.formData.name = obj.goodsName || originalData.name;
                this.formData.spec = obj.spec || originalData.spec;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.error(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function onGoodsScanQuery(_x2) {
        return _onGoodsScanQuery.apply(this, arguments);
      }
      return onGoodsScanQuery;
    }(),
    goodsSearchAsync: function goodsSearchAsync(querystring, callback) {
      if (!querystring) {
        callback([]);
        return;
      }
      this.debounceFunc(querystring, callback);
    },
    onGoodsSearch: function () {
      var _onGoodsSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(querystring, callback) {
        var res, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _inventory.getInventoryGoodsSimpleList)(querystring);
            case 1:
              res = _context3.v;
              callback(res);
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.error('快速查询失败：', _t2);
              callback([]);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      function onGoodsSearch(_x3, _x4) {
        return _onGoodsSearch.apply(this, arguments);
      }
      return onGoodsSearch;
    }(),
    onChildGoodsSelect: function onChildGoodsSelect(item) {
      this.formData.childGoodsId = item.id;
    },
    onChildGoodsClear: function onChildGoodsClear() {
      this.formData.childGoodsId = '';
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var valid, isNew, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return this.$refs.editorFormRef.validate();
            case 1:
              valid = _context4.v;
              if (valid) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              isNew = true;
              if (!this.formData.id) {
                _context4.n = 4;
                break;
              }
              _context4.n = 3;
              return (0, _inventory.updateInventoryGoods)(this.formData);
            case 3:
              isNew = false;
              _context4.n = 5;
              break;
            case 4:
              _context4.n = 5;
              return (0, _inventory.createInventoryGoods)(this.formData);
            case 5:
              this.$message.success("".concat(this.editorType, "\u6210\u529F"));
              this.$emit('success', isNew);
              if (this.formData.id) {
                this.close();
              } else {
                this.resetForm();
              }
              _context4.n = 7;
              break;
            case 6:
              _context4.p = 6;
              _t3 = _context4.v;
              console.error("\u4ED3\u5E93\u5546\u54C1".concat(this.editorType), _t3);
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 6]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }
};